import { combineReducers } from 'redux';

import { authentication } from './authentication.reducer';
import { alert } from './alert.reducer';
import { general } from './general.reducer';

const rootReducer = combineReducers({
  authentication,
  alert,
  general
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js